/* Ramos & Co. — interacciones propias (prefijo rc-) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.rc-reveal:not(.rc-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rc-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('rc-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-rc-contar]');
    if (!els.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-rc-contar')) || 0;
      if (reduce) { el.textContent = fin.toLocaleString('es-ES'); return; }
      var ini = null, dur = 1600;
      function paso(t) {
        if (!ini) ini = t;
        var p = Math.min((t - ini) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = v.toLocaleString('es-ES');
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-rc-parallax]');
    if (!els.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var k = parseFloat(el.getAttribute('data-rc-parallax')) || 0;
        var d = (r.top + r.height / 2 - window.innerHeight / 2) * (k / 100);
        el.style.transform = 'translate3d(0,' + (-d).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initProducto(root) {
    var cajas = (root || document).querySelectorAll('[data-rc-pdp]');
    cajas.forEach(function (caja) {
      if (caja.dataset.rcListo) return;
      caja.dataset.rcListo = '1';

      // Galería
      var principal = caja.querySelector('[data-rc-principal]');
      caja.querySelectorAll('[data-rc-mini]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = btn.getAttribute('data-rc-mini');
            principal.srcset = '';
            principal.style.opacity = 1;
          }, 180);
          caja.querySelectorAll('[data-rc-mini]').forEach(function (b) { b.classList.remove('is-activa'); });
          btn.classList.add('is-activa');
        });
      });

      // Cantidad
      var cant = caja.querySelector('[data-rc-cantidad]');
      caja.querySelectorAll('[data-rc-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!cant) return;
          var v = parseInt(cant.value, 10) || 1;
          v += parseInt(b.getAttribute('data-rc-cant'), 10);
          cant.value = Math.max(1, v);
        });
      });

      // Variantes
      var jsonEl = caja.querySelector('[data-rc-variantes]');
      if (!jsonEl) return;
      var variantes = [];
      try { variantes = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var inputId = caja.querySelector('input[name="id"]');
      var precio = caja.querySelector('[data-rc-precio]');
      var tachado = caja.querySelector('[data-rc-tachado]');
      var ahorro = caja.querySelector('[data-rc-ahorro]');
      var boton = caja.querySelector('[data-rc-boton]');
      var stock = caja.querySelector('[data-rc-stock]');
      var formato = caja.getAttribute('data-rc-moneda') || '{{amount_with_comma_separator}} €';
      var txt = {
        add: caja.getAttribute('data-rc-txt-add'),
        agotado: caja.getAttribute('data-rc-txt-agotado'),
        disponible: caja.getAttribute('data-rc-txt-disponible'),
        noDisp: caja.getAttribute('data-rc-txt-nodisp')
      };

      function dinero(cents) {
        var n = (cents / 100).toFixed(2);
        var partes = n.split('.');
        var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return formato
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + partes[1])
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
          .replace(/\{\{\s*amount\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1]);
      }

      function actualizar() {
        var elegidas = [];
        caja.querySelectorAll('[data-rc-opcion]').forEach(function (fs) {
          var sel = fs.querySelector('input:checked');
          elegidas.push(sel ? sel.value : null);
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        caja.querySelectorAll('[data-rc-opcion]').forEach(function (fs, i) {
          var lab = fs.querySelector('[data-rc-elegido]');
          if (lab) lab.textContent = elegidas[i] || '';
        });
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = txt.noDisp; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) {
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          tachado.textContent = hay ? dinero(v.compare_at_price) : '';
          tachado.hidden = !hay;
          if (ahorro) {
            ahorro.hidden = !hay;
            if (hay) ahorro.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? txt.add : txt.agotado;
        }
        if (stock) {
          stock.textContent = v.available ? txt.disponible : txt.agotado;
          stock.classList.toggle('is-agotado', !v.available);
        }
        if (v.featured_image && principal) {
          principal.src = v.featured_image.src;
          principal.srcset = '';
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      caja.querySelectorAll('[data-rc-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
    });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('[data-rc-comparador]').forEach(function (caja) {
      var rango = caja.querySelector('[data-rc-rango]');
      if (!rango || rango.dataset.rcListo) return;
      rango.dataset.rcListo = '1';
      function mover() { caja.style.setProperty('--rc-pos', rango.value + '%'); }
      rango.addEventListener('input', mover);
      mover();
    });
  }

  function initTodo(root) {
    initReveal(root);
    initContadores(root);
    initProducto(root);
    initComparador(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTodo(document);
    initParallax();
  });

  // Editor de Shopify: reactivar al añadir o cambiar secciones
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
